import React from 'react';
import Icon from '@components/Icon';
import Navbar from '@components/Navbar';
import styles from './index.module.css';
import I18n from '@utils/i18n';
import { useRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import cn from 'classnames';
import { Layout } from 'antd';
const { Header } = Layout;

const DetailLayout = (props) => {
  const {
    hasGoBack = true,
    overFlowHidenContent = false,
    contentClass
  } = props;
  const router = useRouter();
  return (
    <div className={cn(styles.detailLayout, props.className)}>
      <Header>
        <Navbar type="2" />
      </Header>
      {hasGoBack && (
        <div
          className={styles.header}
          onClick={router.back}
        // style={{ cursor: 'pointer' }}
        >
          <div className={styles.headerContent}>
            <div className={styles.backBtn}>
              <Icon style={{ fontSize: '20px' }} name="left" />
              <span className={cn(styles.pagetitle, 'DINPro-Medium')}>
                {I18n.t('gRJfKdS4')}
              </span>
            </div>
          </div>
        </div>
      )}
      <div
        className={cn(styles.content, contentClass, {
          [styles.overflow]: overFlowHidenContent
        })}
        data-name="kiki-detailLayout"
      >
        {props.children}
      </div>
    </div>
  );
};

export default inject((rootStore) => ({
  userStore: rootStore.store.userStore
}))(observer(DetailLayout));
// export default DetailLayout;
